import "unfetch/polyfill";

export default function findCategoryGroups(apiUrl, apiKey) {
  return new Promise(function(resolve, reject) {
    fetch(apiUrl + "category_group?apiKey=" + apiKey)
      .then(r => r.json())
      .then(data => {
        resolve(data);
      })
      .catch(reason => {
        reject(reason);
      });
  });
}
